const infoPillars = {
  Shipping: {
    line1: "Free standard shipping",
    line2: "with orders over $250",
  },
  HelpAndSupport: {
    line1: "Responsive and ",
    line2: "trustworthy support",
  },
  QualityProgram: {
    line1: "Emerson Quality ",
    line2: "Program (EQP)®",
  },
};

export { infoPillars };
